<template>
  <div class="trm-content-start">
    <div class="container">
      <div class="row">
        <div class="col-md-6 align-self-center">
          <br>
          <br>
          <br>
          <el-skeleton style="width: 100%; height: 300px;"
                       :loading="loading"
                       animated
                       :throttle="500">
            <template #template>
              <el-skeleton-item variant="image"
                                style="width: 100%; height: 300px" />
            </template>
            <template #default>
              <img ref="imgRef"
                   src="https://static.igem.wiki/teams/5280/404notfound.svg"
                   alt="404 Not Found"
                   @load="onImageLoad">
            </template>
          </el-skeleton>
        </div>
        <div class="col-md-6 align-self-center">
          <h1>404</h1>
          <p class="trm-mt-20 trm-mb-20">The page you are looking for does not exist. How you got here is a mystery, but you can return to the home page by clicking the button below.</p>
          <a class="trm-btn"
             href="/">HOME</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref, onMounted } from "vue";

const loading = ref(true);
const imgRef = ref<HTMLImageElement | null>(null);

const onImageLoad = () => {
  loading.value = false;
};

onMounted(() => {
  if (imgRef.value && imgRef.value.complete) {
    loading.value = false;
  }
});
</script>